import { createRoot } from 'react-dom/client'
import { QueryClientProvider } from "@tanstack/react-query";
import './index.css'
import App from './App.tsx'
import { Toaster } from 'sonner';
import * as Sentry from "@sentry/react";
import { PostHogProvider } from "posthog-js/react"
import { queryClient } from './lib/react-query.ts';

const options = {
  api_host: import.meta.env.VITE_PUBLIC_POSTHOG_HOST,
  // autocapture: false
  // capture_pageview: false,
}

Sentry.init({
  dsn: "https://41e6abbc504f32635b82af91aca3afd4@o4509100541607936.ingest.us.sentry.io/4509100542590976",
  // enabled: false,
  integrations: [
    Sentry.browserTracingIntegration(),
    // Or, if you are using react router, use the appropriate integration
    // See docs for support for different versions of react router
    // https://docs.sentry.io/platforms/javascript/guides/react/configuration/integrations/react-router/
  ],
  tracePropagationTargets: ["localhost", "https://api-staging.siai.live"],
});

createRoot(document.getElementById('root')!).render(
  <QueryClientProvider client={queryClient}>
    <PostHogProvider apiKey={import.meta.env.VITE_PUBLIC_POSTHOG_KEY} options={options}>
      <Toaster
        visibleToasts={2}
        position="bottom-right"
        richColors
        toastOptions={{
          // unstyled: true/*  */,
          classNames: {
            title: "text-sm font-poppins tracking-wide font-medium",
            description: "text-xs font-poppins tracking-wide"
          },
        }}
      />

      <App />
    </PostHogProvider>
  </QueryClientProvider>
  ,
)
